import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function maskString(str: string | undefined | null): string {
  if (!str) return "••••••••";
  if (str.length <= 4) return "••••" + str;
  return "••••••••" + str.slice(-4);
}
